/* eslint-disable react-hooks/exhaustive-deps */
import {
  Sort as HeadlessSort
} from '@coveo/headless';
import React, { FunctionComponent, useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setActiveActionSearchBox, setActiveSortState, setCurrentSortState} from '../../../actions/searchBoxAction';
import { pillId } from '../../../utils/utils';
import './Sort.scss';
import * as ReactRedux from "react-redux";
interface SortProps {
  controller: HeadlessSort;
  criteria: any;
  controllerTabPill: any;
  pillType?: number;
  tabType?: any;
  isShowRecommendedForModel?: any;
  isMobile?: boolean
  currentSort?: string
  activeSort?: string
}

export const Sort: FunctionComponent<SortProps> = (props) => {
  const { controller, isMobile, currentSort, activeSort } = props;
  const getCriterionFromName = (name: string) =>
    props.criteria.find(([criterionName]: any) => criterionName === name)!;
  const dispatch = useDispatch();
  useEffect(() => {
    initSort();
  }, [
    controller, props.pillType, props.tabType, props.isShowRecommendedForModel
  ]);

  // Initiate Sort dropdown
  function initSort() {
    const sortDropdown = document.getElementById("rightSectionSortId") || null;
    // Set the default Sort value to Most Relevant
    if(currentSort !== "Most Relevant") {
      controller.sortBy(getCriterionFromName("Most Relevant"));
      // selectedOption && (selectedOption.innerHTML = "Most Relevant");
      // addCurrentSortClassToItem("Most Relevant");
    }
  }


  function toggleSortingOptions(e: any) {
    e.stopPropagation();
    // setActiveSort(!activeSort);
    dispatch(setCurrentSortState({value: currentSort}));
    dispatch(setActiveSortState({value: activeSort}));

  }

//close sort
  const body = document.getElementsByTagName('body')[0];
  body.onclick = (e: any) => {
    let currentElm = e.target;
    if (activeSort && currentElm.id != "rightSectionSortId" && !currentElm.closest(".rightSectionSort")) {
      dispatch(setActiveSortState({value: false}));
    }
  };


  function sort(e: any) {
    dispatch(setActiveActionSearchBox(false));
    dispatch(setCurrentSortState({value: e.target.innerHTML}));
    dispatch(setActiveSortState({value: false}));
    sendData(e.target.innerHTML);
  }

  function sendData(sortLabel: string) {
    let payloadSort: any = [];
    if(sortLabel === 'Featured' ){
      if( props.pillType === pillId.PRODUCT){
        payloadSort = ['Featured',{
          by: "field",
          field: "is_featured",
          order: "descending"
        }, 'Title a-z', {
          by: "field",
          field: "title",
          order: "ascending"
        }]
      }else {
        payloadSort = ['Featured',{
          by: "field",
          field: "aem_featured",
          order: "descending"
        }, 'Title a-z', {
          by: "field",
          field: "title",
          order: "ascending"
        }]
      }
      controller.sortBy(payloadSort);
    }else if(sortLabel === 'Most Popular'){
      payloadSort = ['Most Popular',{
        by: "field",
        field: "aem_mostpopular",
        order: "ascending"
      }, 'Title a-z', {
        by: "field",
        field: "title",
        order: "ascending"
      }]
      controller.sortBy(payloadSort);
    } else if(sortLabel === 'Best Sellers'){
      payloadSort = ['Best Sellers',{
        by: "field",
        field: "bestsellers",
        order: "descending"
      }, 'Title a-z', {
        by: "field",
        field: "title",
        order: "ascending"
      }]
      controller.sortBy(payloadSort);
    } else if(sortLabel === 'Newest' && props.pillType === pillId.PRODUCT){
      payloadSort = ['Newest',{
        by: "field",
        field: "created_at",
        order: "descending"
      }, 'Title a-z', {
        by: "field",
        field: "title",
        order: "ascending"
      }]
      controller.sortBy(payloadSort);
    } else if (sortLabel === 'Price High to Low') {
      payloadSort = ['Price High to Low',{
        by: "field",
        field: "final_price",
        order: "descending"
      }, 'Title a-z', {
        by: "field",
        field: "title",
        order: "ascending"
      }]
      controller.sortBy(payloadSort);
    } else if (sortLabel === 'Price Low to High') {
      payloadSort = ['Price Low to High',{
        by: "field",
        field: "final_price",
        order: "ascending"
      }, 'Title a-z', {
        by: "field",
        field: "title",
        order: "ascending"
      }]
      controller.sortBy(payloadSort);
    } else {
      controller.sortBy(getCriterionFromName(sortLabel));
    }
  }

  return (
    <div className={isMobile ? "rightSectionSort mobile-sort" : "rightSectionSort"} id="rightSectionSortId" onClick={(e) => {
      dispatch(setActiveSortState({value: !activeSort}));
    }}>
      <span className="sortFilterContainer">
        <span className="sortSpan">Sort By<span className="colon-label">:</span></span>
        <span className="sortSelectedOption">{currentSort}</span>
      </span>
      <span className="sortIconContainer">
        <span className={activeSort ? "sortIcon open" : "sortIcon"}></span>
      </span>
      <div className={activeSort ? "sort-dropdown-items open" : "sort-dropdown-items"}>
        {props.criteria.map(([criterionName]: any) => (
            <div className={criterionName == currentSort ?"dropdown-item current-sort" : "dropdown-item"} key={criterionName} onClick={(e) => {
              // @ts-ignore
              window.isSortRecommended = criterionName === "Recommended";
              return sort(e);
            }}>
            {criterionName}
          </div>
        ))}
      </div>
    </div>
  );
};